module.exports = "./img/fc9c9e4c9af187ee5bc385fabae06b23.jpg";